package com.eladfinish.bible.contest.utils.spreadsheet

import kotlin.math.abs

fun String.getId(): String {
    if (this.matches("[a-zA-Z0-9_-]+".toRegex())) {
        return this
    }
    val str = "/d/"
    val beginIndex = this.indexOf(str) + str.length
    var endIndex = this.lastIndexOf("/")
    if (abs(endIndex - beginIndex) <= 1) {
        endIndex = this.length
    }
    return this.substring(beginIndex, endIndex)
}
